<template>
    <section>
      <div class="extra-products">
        <h1>Additional Items</h1>
          <div class="products">
            <div class="product-card"  v-for="product in products" :key="product.id">
              <img :src="product.imageUrl" :alt="product.name" >
              <h2>{{product.name}}</h2>
              <p class="product-description">{{product.byLine}}</p>
              <p class="product-size">{{!product.sizes[0] ? '' : product.sizes[0].value}}</p>
              <p class="price">{{ price(product) }}</p>
              <button class="button-dark" v-on:click="addToCart(product)">Add to Cart</button>
            </div>
          </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "extra-products",
  methods: {
    addToCart(product) {
      this.$store.dispatch('CART/ADD',product)
    },
     price (product) {
       return this.currencyFormatter(product).replace("kr", "SEK"); 
    },
    currencyFormatter(product) {
      //todo: get localization
      var localization = 'sv-SE';
      return new Intl.NumberFormat(localization, {
          style: 'currency',
          currency: !product.currency ? 'SEK' : product.currency,
          minimumFractionDigits: 0
      }).format(product.price);
    }

  },
  computed: {
    products() {
      return this.$store.getters['PRODUCTS/RELATED_PRODUCTS']
    }
  }
}
</script>

<style lang="postcss" scoped>
.extra-products {
  width: 100%; 
  height: 100%; 
  margin: auto; 
  padding:5% 5% 12% 5%;
}
h1 { 
    width: 100%; 
    text-align: center; 
    padding-bottom: 6%;
    font-weight: 100;
    font-size: 1.9em;
}

.products {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: space-around;
  flex: 1 1 1 1 ;
}
.product-card {
  text-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  width: 20%;
  min-width: 200px;
}
.product-description,
{
    line-height: 1em;
}
.product-size {
  line-height: 0;
}
img {
  height: 316px;
  width: 100%; 
}

.product-card h2,
.product-card h3 {
  font-weight: 100;
  margin-bottom: 0;
  line-height: 1.2em;
  
}
.product-card h4 {
  margin-top: 0.3em;
  font-weight: 100;
  margin-top: 5%;
}
.price {
  margin-top: 18%;
}
 button {
  width: 100%;
}


@media screen and (max-width: 780px) {
  .extra-products {padding-bottom: 0% }
  .products {flex-direction: column;  }
  .product-card {
    width: 100%;
    max-width: 100%;
    margin-bottom: 30%;
  }
  .price {
  margin-top: 10%;
}
  button {
    width:256px;
    margin-left: auto; 
    margin-right:auto; 
    display: flex;
    justify-content: center;
  }
  h2 {
    font-size: 1.4em;
  }

  img {
    max-width: 300px;
  }

}


</style>